var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapPin = function SvgMapPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 .667c-3.314 0-6 2.54-6 5.671 0 2.295 3.22 7.284 4.943 9.786.233.338.63.543 1.056.543a1.28 1.28 0 0 0 1.058-.542C8.778 13.622 12 8.634 12 6.338 12 3.206 9.314.667 6 .667Zm0 7.977c-1.384 0-2.505-1.06-2.505-2.368 0-1.308 1.121-2.368 2.505-2.368s2.505 1.06 2.505 2.368c0 1.308-1.121 2.368-2.505 2.368Z",
    fill: "currentColor"
  })));
};
export default SvgMapPin;